
export default class GlassStructure 
{

  constructor(webGlComponent, uiHandler, applicationFilter) 
  {
	  this.webGlComponent = webGlComponent;
    this.fireResistentGlass = undefined;
    this.middleGlass = undefined;
    this.outerGlass = undefined;
    this.spacerMiddle = {};
    this.spacerOutside = {};
    this.uValue = '5,4';
    this.gasMiddle = 0;
    this.gasOutside = 0;
    this.uiHandler = uiHandler;
    this.applicationFilter = applicationFilter;
  }

  setSpacers(spacerOutside, spacerMiddle, gasOutside, gasMiddle) 
  {
  		this.spacerOutside.thickness = spacerOutside; 
  		this.spacerMiddle.thickness = spacerMiddle;
  		
  		this.gasOutside = gasOutside; 
  		this.gasMiddle = gasMiddle;
  		this.calculate_width();
  }

  setOuterGlass(outerGlass) 
  {
    this.outerGlass = outerGlass;
    this.calculate_width();
  }

  setMiddleGlass(middleGlass) 
  {
    this.middleGlass = middleGlass;
    this.calculate_width();
  }

  setFireResistentGlass(fireResistentGlass) 
  {
    this.fireResistentGlass = fireResistentGlass;
    this.calculate_width();
  }

  setUV(uv) 
  {
  	this.uValue = uv;
    this.calculate_width();
  }

  calculate_width() 
  {
  	let invert_frg = false;

  	if (this.applicationFilter.filterName === 'Outside/Outside') 
    {
    	invert_frg = true;
  	}

    	this.webGlComponent.updateLabels(
    	  	this.fireResistentGlass,
    	  	this.outerGlass,
    	  	this.middleGlass,
    	  	this.spacerOutside,
    	  	this.spacerMiddle,
    	  	this.uValue,
    	  	this.gasOutside,
    	  	this.gasMiddle,
    	  	invert_frg
    	);

    	this.webGlComponent.setSun(this.applicationFilter.filterName !== 'Inside');
    	
    	this.uiHandler.set(this.fireResistentGlass.sound, this.outerGlass);
  }
}
